import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Wrapper that provides consistent styling for the Stripe PaymentElement section.
 */
export default function CheckoutPaymentContainer({
  title = 'Payment Information',
  children,
  className = '',
}) {
  return (
    <div className={classNames('checkout-payment-container', className)}>
      <div className="payment-section-header">
        <h4>{title}</h4>
      </div>

      <div className="payment-element-wrapper">{children}</div>
    </div>
  );
}

CheckoutPaymentContainer.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
